<div class="content">
    <div class="content__padding">
        <div class="content__wrapper"
             appFitToParent
             [style.width.px]="contentWrapperWidth"
             [style.height.px]="contentWrapperHeight"
             [autoFit]="false">
            <ng-content></ng-content>
        </div>
    </div>
</div>
<div class="options">
    <ng-template #optionsTarget></ng-template>
</div>
